<script>
  import { Router, Route } from 'svelte-navigator'
  import ExerciseList from './exercises/ExerciseList.svelte'
  import ExerciseDetail from './exercises/ExerciseDetail.svelte'
</script>

<Router primary={false}>
  <Route path="/">
    <ExerciseList />
  </Route>
  <Route path="/details/:id" let:params>
    <ExerciseDetail id={params.id} />
  </Route>
</Router>
